import { faSeedling, faCircleUser } from '@fortawesome/pro-regular-svg-icons'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

import { Icon, List, Popover, Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { RailNavListRestructured } from './RailNavListRestructured'
import { Header } from './RailHeader'

interface RailRestructuredProps {
  device: string
  dropdownOptions: Array<{ icon: IconProp; onClick: () => void; text: string }>
  categories?: Record<
    string,
    {
      end?: boolean
      icon?: IconProp
      label: string
      to?: string
      disabled?: boolean
    }
  > | null
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onCategoryClick?: (key: string) => void
  onAskHaven?: () => void
}

export const RailRestructured = ({
  device,
  dropdownOptions,
  categories,
  isOpen,
  setIsOpen,
  onCategoryClick,
  onAskHaven,
}: RailRestructuredProps) => {
  const railWidth = isOpen ? 'w-64' : 'w-[68px]'
  return (
    <nav
      className={`
        flex flex-col bg-app h-screen
        overflow-y-auto px-4 py-4
        ${railWidth}
        transition-[width] duration-200
      `}
    >
      <div className="flex flex-col gap-10">
        <Header
          device={device}
          handleIconClick={() => setIsOpen(!isOpen)}
          isOpen={isOpen}
        />

        <RailNavListRestructured
          categories={categories}
          onCategoryClick={onCategoryClick}
        />
      </div>

      <footer className="mt-auto pt-6 flex flex-col gap-0.5 items-center">
        {onAskHaven && (
          <button
            type="button"
            className={mtc(
              'flex items-center justify-center',
              'h-8 w-9 shrink-0',
              'border-none rounded-[10px]',
              'hover:bg-neutral-50 cursor-pointer'
            )}
            onClick={onAskHaven}
            data-rail-passthrough=""
            aria-label="Ask Haven"
          >
            <Icon
              icon={faSeedling}
              color="text-neutral-700"
              className="w-5 h-5 shrink-0"
              backgroundClassName="w-5 h-5 shrink-0"
            />
          </button>
        )}

        <Popover>
          <Popover.Trigger asChild>
            <button
              type="button"
              className={mtc(
                'flex items-center justify-center',
                'h-8 w-9 shrink-0',
                'border-none rounded-[10px]',
                'hover:bg-neutral-50 cursor-pointer'
              )}
              onClick={() => setIsOpen(true)}
              aria-label="User menu"
            >
              <Icon
                icon={faCircleUser}
                color="text-neutral-700"
                className="w-5 h-5 shrink-0"
                backgroundClassName="w-5 h-5 shrink-0"
              />
            </button>
          </Popover.Trigger>

          <Popover.Content align="end" className="w-fit">
            <List className="flex flex-col">
              {dropdownOptions.map(({ icon, onClick, text }) => (
                <List.Item
                  onClick={onClick}
                  key={text}
                  className="flex flex-row gap-2 cursor-pointer"
                >
                  <Icon icon={icon} className="shrink-0" />
                  <Text
                    variant={TypographyStyles.BODY_SM}
                    color={TextColors.EMPHASIS}
                  >
                    {text}
                  </Text>
                </List.Item>
              ))}
            </List>
          </Popover.Content>
        </Popover>
      </footer>
    </nav>
  )
}
